import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div {{did-insert (perform this.loadEditor) this.options}} {{did-update (perform this.loadEditor) this.options}} id={{this.editorId}} class=\"html-editor\">\n</div>\n", {
  moduleName: "ilios-common/components/html-editor.hbs"
});